import React from "react";

const Modal = (props) => {
    const { mostrarModal, mensaje, atlas } = props;
    let descripcion = ((atlas.entidadInstanciaId) ? "Editar " : "Nueva ") + "Instancia Parametro";
    if (mostrarModal) {
        return <div className="atlas">
            <div className="modal fade in" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"
                style={{ display: "block", paddingRight: "17px" }}>
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{descripcion}</h5>
                        </div>
                        <div className="modal-body">
                            <p>{mensaje}</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn-orange" onClick={props.finalizarSaga}>Ok</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade in"></div>
        </div>
    }
    else {
        return null;
    }
}

export default Modal;